import { Entity } from "../Entity";
import { ImageService } from "./ImageService";
import { graphic } from "../../Graphic";

export class Image extends Entity {

    constructor({
        id = null,
        name,
        container,
        graphicItems,
        width,
        height
    }) {
        super({ id, container, graphicItems, type: 'image' });
        this.width = width;
        this.height = height;
        this.name = name;
    }

    clone() {
        return ImageService.createFromProps(this.getProps());
    }

    getProps() {
        return {
            ...super.getProps(),
            width: this.width,
            height: this.height,
            name: this.name
        };
    }

    onClickEntity() {
        if (!graphic.blockImages) super.onClickEntity();
    }

    onOverEntity() {
        if (!graphic.blockImages) super.onOverEntity();
    }

    onOutEntity() {
        if (!graphic.blockImages) super.onOutEntity();
    }

    draw() {
        console.log('draw image')
        super.draw(0);
    }

    moveInWorldSpace() {
        super.moveInWorldSpace(0, true);
    }

    updateFromProps(rowProps, bindProps = null) {
        super.updateFromProps(
            rowProps,
            bindProps,
            props => ImageService.createFromProps(props),
            newEntity => {}
        )
    }
}